import { render } from "./SallesList.vue?vue&type=template&id=2aabe978&scoped=true"
import script from "./SallesList.vue?vue&type=script&lang=js"
export * from "./SallesList.vue?vue&type=script&lang=js"

import "./SallesList.vue?vue&type=style&index=0&id=2aabe978&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aabe978"]])

export default __exports__